<cwc-header
  class="global-header"
  [showMenuButton]="true"
  variant="positive"
  show-menu-button="mobile"
  show-cemex-logo="false"
  (cwcSidenavToggle)="sidenavToggleClick()"
>
  <div class="image-container" slot="logo">
    <img [src]="logo" *ngIf="!isDarkMode" />
    <img [src]="logoDark" *ngIf="isDarkMode" />
  </div>
  <div class="nav-header__section">
    <cwc-popover *ngIf="isLocalWeb && !isArkikOnline()">
      <div class="flex flex__align--center m-end-xs">
        <div
          class="display-inline-block p-all-xs offline offline-color"
          [ngClass]="{ 'outdated-color': migrationStatus !== eEdgeMigrationStatus.UpToDate }"
        >
          <cwc-icon
            name="information-rounded-fill"
            class="offline-color"
            [ngClass]="{ 'outdated-color': migrationStatus !== eEdgeMigrationStatus.UpToDate }"
          ></cwc-icon>
          {{
            (migrationStatus === eEdgeMigrationStatus.UpToDate
              ? 'views.globals.offline.notice'
              : 'views.globals.offline.outOfDate.notice'
            ) | translate
          }}
        </div>
      </div>
      <div slot="content" style="padding: 1rem; width: 250px">
        {{ 'views.globals.offline.advice' | translate }}
      </div>
    </cwc-popover>

    <cwc-popover *ngIf="isDispatch && alertsEnabled" (cwcShow)="onAlertShow($event)">
      <div slot="target" class="flex flex__align--center m-end-xs">
        <div
          *ngIf="alerts.length > 0"
          class="display-inline-block p-all-xs border-radius--circle bg--true-red custom-badge"
          style="font-size: 0.781em"
        >
          {{ unReadAlertCountString | wrapFn: alerts }}
        </div>
        <cwc-button *ngIf="alerts.length === 0" slot="target" variant="link" [white]="!isDarkMode" class="header-icon">
          <span class="nav-header__icon nav-header__icon--consoles">
            <cwc-icon name="notification" [color]="!isDarkMode ? 'true-white' : 'dark-grey'" size="1.25rem"></cwc-icon>
          </span>
        </cwc-button>
      </div>
      <div slot="content" style="padding: 24px; width: 426px; height: 360px">
        <span class="controls-container">
          <cwc-segmented-controls (cwcControlActive)="onTypeChanged($event)">
            <cwc-segmented-controls-item active="true" name="unread"
              >{{ 'views.alerts.unread' | translate }} ({{
                unReadAlertCount | wrapFn: alerts
              }})</cwc-segmented-controls-item
            >
            <cwc-segmented-controls-item name="read">{{ 'views.alerts.read' | translate }}</cwc-segmented-controls-item>
          </cwc-segmented-controls>
          <cwc-button *ngIf="showUnReadAlerts" variant="link" class="right-align" (cwcClick)="markAllAsRead($event)">{{
            'views.alerts.mark-all-as-read' | translate
          }}</cwc-button>
        </span>
        <span
          class="wrapper"
          style="display: block; height: 300px; margin-top: 5px"
          (scroll)="onScrollAlerts($event)"
          #alertWrapper
        >
          <div
            *ngIf="(unReadAlertCount | wrapFn: alerts) === 0 && showUnReadAlerts"
            style="padding-top: 2.5em; padding-left: 2em; width: 90%"
          >
            <cwc-empty-result
              header="{{ 'views.globals.initial.empty-header' | translate }}"
              icon="information-rounded-fill"
              variant="flat"
            ></cwc-empty-result>
          </div>
          <div
            *ngIf="(readAlertCount | wrapFn: alerts) === 0 && !showUnReadAlerts"
            style="padding-top: 2.5em; padding-left: 2em; width: 90%"
          >
            <cwc-empty-result
              header="{{ 'views.globals.initial.empty-header' | translate }}"
              icon="information-rounded-fill"
              variant="flat"
            ></cwc-empty-result>
          </div>
          <ng-container *ngFor="let alert of showUnReadAlerts ? alertsUnRead : alertsRead">
            <ng-container *ngIf="!alert.isRead">
              <div class="p-h-xs" *ngIf="showUnReadAlerts">
                <div class="p-all-sm font--dark-grey flex" style="border-bottom: 1px solid #d6d6d6">
                  <div style="flex: 0">
                    <cwc-icon name="circle-filled" size="1rem" color="bright-blue" class="m-end-sm"></cwc-icon>
                  </div>
                  <div style="flex: 1">
                    <div class="alert-header">
                      <div class="copy-c2-medium">{{ 'views.alerts.type-' + alert.alertTypeId | translate }}</div>
                      <div class="copy-c5-medium">{{ alert.dateCreate | date: dateFormat : null : locale }}</div>
                    </div>
                    <p class="copy-c4-regular">{{ getDescription | wrapFn: alert }}</p>
                    <div class="text-end copy-c2-medium" style="color: #1697f3">
                      <cwc-button variant="link" (cwcClick)="markAsRead(alert.alertId, $event)">{{
                        'views.alerts.view' | translate
                      }}</cwc-button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="alert.isRead">
              <div class="p-h-xs" *ngIf="!showUnReadAlerts">
                <div class="p-all-sm font--dark-grey flex" style="border-bottom: 1px solid #d6d6d6">
                  <div style="flex: 0">
                    <cwc-icon name="circle-stroke" size="1rem" color="bright-blue" class="m-end-sm"></cwc-icon>
                  </div>
                  <div style="flex: 1">
                    <div class="alert-header">
                      <span class="copy-c2-medium">{{ 'views.alerts.type-' + alert.alertTypeId | translate }}</span>
                      <span class="copy-c5-medium text-end">{{
                        alert.dateCreate | date: dateFormat : null : locale
                      }}</span>
                    </div>
                    <p class="copy-c4-regular">{{ getDescription | wrapFn: alert }}</p>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </span>
      </div>
    </cwc-popover>

    <cwc-popover #bomBellPopover *ngIf="!isLocalWeb && isOrderModule">
      <div slot="target" class="bom-bell-container header-icon">
        <span class="nav-header__icon nav-header__icon--consoles">
          <cwc-icon name="notification" [color]="!isDarkMode ? 'true-white' : 'dark-grey'" size="1.25rem"></cwc-icon>
        </span>
        <span class="bom-bell-dot" *ngIf="bomBellDotVisible$ | async"></span>
      </div>
      <div slot="content" class="bom-bell-content">
        <ng-container *ngIf="bomBellNotifications$ | async as notifications">
          <div *ngIf="notifications.length === 0" class="bom-bell-empty">
            <cwc-empty-result
              header="{{ 'views.orders.back-order-mgmnt.notifications.empty' | translate }}"
              icon="information-rounded-fill"
              variant="flat"
            ></cwc-empty-result>
          </div>
          <ng-container
            *ngFor="let n of notifications"
            [ngTemplateOutlet]="notificationCard"
            [ngTemplateOutletContext]="{ n: n }"
          ></ng-container>
        </ng-container>
      </div>
    </cwc-popover>

    <div class="bom-toast" *ngIf="!isLocalWeb && isOrderModule && (toastNotification$ | async) as toast">
      <ng-container [ngTemplateOutlet]="notificationCard" [ngTemplateOutletContext]="{ n: toast }"></ng-container>
    </div>

    <ng-template #notificationCard let-n="n">
      <div class="bom-card">
        <div class="bom-card__head">
          <span class="bom-card__icon">
            <cwc-icon name="notification" size="0.85rem" color="true-white"></cwc-icon>
          </span>
          <span class="bom-card__title">
            {{ 'views.orders.back-order-mgmnt.notifications.card-title' | translate: [n.orderCode] }}
            <span class="bom-card__title-status">{{
              'views.orders.back-order-mgmnt.notifications.card-title-status' | translate
            }}</span>
          </span>
        </div>
        <p class="bom-card__body">{{ 'views.orders.back-order-mgmnt.notifications.card-body' | translate }}</p>
        <div class="bom-card__foot">
          <span class="bom-card__pill bom-card__pill--{{ getNotificationSeverity(n.changedAt) }}">
            <cwc-icon name="clock-fill" size="0.75rem" [color]="getNotificationClockColor(n.changedAt)"></cwc-icon>
            {{ getTimeAgo(n.changedAt) }}
          </span>
          <a class="bom-card__open" (click)="onBomNotificationOpen(n)">
            {{ 'views.orders.back-order-mgmnt.notifications.open' | translate }}
            <cwc-icon name="arrow-right-single" size="0.7rem" color="bright-blue"></cwc-icon>
          </a>
        </div>
      </div>
    </ng-template>

    <cwc-popover #appsMenu>
      <cwc-button slot="target" variant="link" [white]="!isDarkMode" class="header-icon">
        <span class="nav-header__icon nav-header__icon--consoles">
          <cwc-icon
            name="modules-internal-consoles"
            [color]="!isDarkMode ? 'true-white' : 'dark-grey'"
            size="1.25rem"
          ></cwc-icon>
        </span>
      </cwc-button>
      <div slot="content" class="nav-header__apps-popover">
        <h3 class="nav-header__apps-heading">{{ 'views.home.my-apps' | translate }}</h3>
        <ul class="nav-header__apps-list">
          <li
            class="nav-header__apps-item"
            role="button"
            *ngFor="let item of applicationMenus; index as i"
            [tabindex]="i + 1"
          >
            <div *ngIf="item.active" class="item-hover" (click)="appInterfaceSelected(item)">
              <img *ngIf="appIconSrcByGuid[item.applicationGuid] as iconSrc" [src]="iconSrc" />
              <span class="dataTextBlack">{{ item.name }}</span>
            </div>
          </li>
        </ul>
        <div class="nav-header__apps-footer">
          <cwc-button variant="link" (cwcClick)="goToHome()">
            {{ 'views.globals.go-to-home' | translate }}
          </cwc-button>
        </div>
      </div>
    </cwc-popover>

    <ng-container *ngIf="isCemexAccount">
      <cwc-popover>
        <cwc-button slot="target" variant="link" [white]="!isDarkMode" class="header-icon">
          <span class="nav-header__icon nav-header__icon--consoles">
            <cwc-icon name="new-window" [color]="!isDarkMode ? 'true-white' : 'dark-grey'" size="1.25rem"></cwc-icon>
          </span>
        </cwc-button>
        <div slot="content" class="nav-header__links-popover contentLinks">
          <h3 class="nav-header__apps-heading">{{ 'views.globals.my-links' | translate }}</h3>
          <div class="nav-header__item nav-header__links-actions">
            <span class="linksIcons">
              <cwc-icon name="module-commercial-condition" [color]="'medium-grey'" size="1rem"></cwc-icon> </span
            >&nbsp;
            <a
              class="hide-link"
              #arkikSupport
              target="_blank"
              href="https://teams.microsoft.com/l/app/dbec24c6-9761-4234-9af2-7ee3dffca3c7?source=app-details-dialog"
            ></a>
            <cwc-button variant="link" (cwcClick)="arkikSupport.click()">
              {{ 'views.globals.arkik-support' | translate }}
            </cwc-button>
          </div>
          <div class="nav-header__item nav-header__links-actions">
            <span class="linksIcons"> <cwc-icon name="share" [color]="'medium-grey'" size="1rem"></cwc-icon> </span
            >&nbsp;
            <a class="hide-link" #arkikNews target="_blank" href="https://cemex.sharepoint.com/sites/arkikusa"></a>
            <cwc-button variant="link" (cwcClick)="arkikNews.click()">
              {{ 'views.globals.arkik-knowledge-hub' | translate }}
            </cwc-button>
          </div>
          <div class="nav-header__item nav-header__links-actions">
            <span class="linksIcons"> <cwc-icon name="video" [color]="'medium-grey'" size="1rem"></cwc-icon> </span
            >&nbsp;
            <a
              class="hide-link"
              #arkikLearningCenter
              target="_blank"
              href="https://apps.powerapps.com/play/e/default-6ee19001-d0c4-45f8-af8b-ff00f16d07e1/a/26660d6c-b617-4372-94be-2f286d030cf2?tenantId=6ee19001-d0c4-45f8-af8b-ff00f16d07e1&source=portal"
            ></a>
            <cwc-button variant="link" (cwcClick)="arkikLearningCenter.click()">
              {{ 'views.globals.arkik-certification-program' | translate }}
            </cwc-button>
          </div>
        </div>
      </cwc-popover>
    </ng-container>

    <cwc-popover>
      <div slot="target" class="header-icon">
        <cwc-avatar
          size="small"
          variant="positive"
          class="cwc-avatar"
          [name]="FullName"
          [imageSource]="imagePath"
        ></cwc-avatar>
      </div>
      <div slot="content" class="nav-header__account-popover">
        <div class="nav-header__item nav-header__account-info">
          <div class="nav-header__account-info__avatar">
            <cwc-avatar
              size="small"
              variant="positive"
              class="cwc-avatar"
              [name]="FullName"
              [imageSource]="imagePath"
            ></cwc-avatar>
          </div>
          <div class="nav-header__account-info__name">
            <span class="account-fullname">{{ FullName }}</span>
            <span class="account-email">{{ Email }}</span>
          </div>
        </div>
        <div class="nav-header__item nav-header__account-actions" *ngIf="isDarkModeEnabled">
          <cwc-switch
            [checked]="isDarkMode"
            (cwcChange)="toggleDarkMode($event)"
            [disabled]="!isDarkModeEnabled"
            class="action__dark-mode"
          >
            {{ 'views.globals.dark-mode' | translate }}
          </cwc-switch>
        </div>
        <div class="nav-header__item nav-header__account-actions">
          <a class="hide-link" #varMyAccount href="/myaccount"></a>
          <cwc-button variant="link" (cwcClick)="varMyAccount.click()">
            {{ 'views.globals.my-account' | translate }}
          </cwc-button>
        </div>
        <div class="nav-header__item nav-header__account-actions">
          <cwc-button variant="link" (cwcClick)="SignOut()" class="action__sign-out">
            {{ 'Singout' | translate }}
          </cwc-button>
        </div>
      </div>
    </cwc-popover>
  </div>
  <cwc-header-selector
    [data]="languages"
    showSeparator="true"
    leadingIcon="language"
    variant="positive"
    (cwcSelectorChange)="changeLanguage($event)"
  ></cwc-header-selector>
</cwc-header>
